module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_fukuoka-1db1648ca4847e5aac44ceb50d378cee.png";